if(jQuery("#kochen-product").length) {
    jQuery("#kochen-product .products-slider").slick({
        centerMode: true,
        centerPadding: '100px',
        slidesToShow: 6,

        responsive: [
            {
            breakpoint: 1100,
            settings: {
             arrows: false,
             centerMode: false,
             centerPadding: '20px',
             slidesToShow: 4,
             dots: true,
             dotsClass: 'slick-dots hero-slider__dots',
                }
              },
          {
            breakpoint: 800,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '80px',
              slidesToShow: 2,
              dots: true,
              dotsClass: 'slick-dots hero-slider__dots',
              variableWidth: true

            }
          },
          {
            breakpoint: 480,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '0',
              slidesToShow: 1,
              dots: true,
              dotsClass: 'slick-dots hero-slider__dots',
            }
          }
        ]
      });
}
